import { render } from "./AudioArea.vue?vue&type=template&id=026144a9"
import script from "./AudioArea.vue?vue&type=script&lang=ts"
export * from "./AudioArea.vue?vue&type=script&lang=ts"
script.render = render

export default script